<template>
	<div id="app" :class="classname">
		<div id="main-wrapper">
			<vue-min-header v-if="secure" :config="config" :helpText="helpText"></vue-min-header>
			<Sidebar :navItems="nav" :isCollapse="isCollapse" :config="config" :height="windowHeight" v-if="secure"/>
			<div class="page-wrapper">
				<vue-min-breadcrumb v-if="secure" :route="name" ></vue-min-breadcrumb>
				<div class="container-fluid" id="contentStart">
					<div v-if="pageText" class="pageTextIntro" v-html="pageText"></div>
					<router-view :key="$route.path" :config="config" :height="windowHeight" ></router-view>
				</div>
			</div>
			<vue-footer v-if="secure" :config="config"></vue-footer>
		</div>
	</div>
</template>

<script>
import nav from './nav';
import { mapGetters } from 'vuex';
import Preloader from './components/global/Preloader.vue';
import Header from './components/global/Header.vue';
import Breadcrumb from './components/global/Breadcrumb.vue';
import Sidebar from './components/global/Sidebar.vue';
import Footer from './components/global/Footer.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import Util from './assets/js/util.js';

	router.beforeEach((to, from, next) => {
		document.title = to.name;
		if (to.fullPath == '/') {
			if (localStorage.returnURL && localStorage.returnURL != '/') {
				next({
					path: localStorage.returnURL,
					query: {}
				});
			} else {
				next({
					path: '/dashboard',
					query: {}
				})
			}
		}
		if (to.matched.some(record => record.meta.requiresAuth)) {
			// this route requires auth, check if logged in
			// if not, redirect to login page.
			if (!loggedInUser()) {
				localStorage.returnURL = to.fullPath ;
				next({
					path: (localStorage.subdomain ? '/' + localStorage.subdomain : '') + '/login',
					query: {}
				});
			} else {
				if (to.matched.some(record => record.meta.requiresSecurity)) {
				    //user is logged in as required, now determine if their roles allows access to this page
				    let validAccess = false;
				    var fullPath = to.fullPath.substr(1).split('/');

	                for (let i=0; i < store.state.auth.user.RoleSecurity.length; i++) {
	                    if (store.state.auth.user.RoleSecurity[i].SecurityAreaCode == fullPath[0]) {
	                        if ((store.state.auth.user.RoleSecurity[i].Params.Access && store.state.auth.user.RoleSecurity[i].Params.Access == 'true' ) || store.state.auth.user.RoleSecurity[i].Params.ReadAccess) {
								validAccess = true;
								break;
	                        }
	                    }
	                }
	                if (validAccess) {
						localStorage.returnURL = to.fullPath;
	                    next();
	                } else {
						next({
							path: '/dashboard',
							query: {}
						});
					}
				} else {
					localStorage.returnURL = to.fullPath;
                    next();
                }
			}
		} else {
			next(); // make sure to always call next()!
		}
	});

	function loggedInUser () {
		if (Util.readCookie('login') && store.state.auth.user) {
			return true;
		} else {
			return false;
		}
	}

    export default {
        data (){
          	return{
                config: {Params : {}},
	            helpText : '',
				pageText : '',
	            isCollapse : false,
	            windowHeight: 600,
	            trickleSpeed: 250,
	            dataToBeSaved: '',
          	}
        },
        components: {
			VueMinPreloader: Preloader,
			VueMinHeader: Header,
			VueMinBreadcrumb: Breadcrumb,
			Sidebar,
			VueFooter: Footer
        },
        computed: {
	        nav() {
		        return nav.items;
	        },
			name(){
	        	if (this.$route.name) {
			        return this.$route.name;
		        } else {
	        		return 'test';
		        }
			},
            classname(){
                if(this.$route.name) {
                    return this.$route.name.replace(/\s/g, '').toLowerCase();
                } else {
                    return '';
                }
            },
			securityPath() {
	        	var fullPath = this.$route.fullPath.substr(1).split('/');
				return fullPath[0];
			},
			secure(){
				return this.$route.meta.requiresAuth;
			},
	        list() {
		        return this.$route.matched;
	        },
			...mapGetters({ currentUser: 'currentUser' }),

		},
	    watch:{
		    $route (to, from){
			    this.getHelp(to.fullPath);
		    }
	    },
		created () {
/*
			emitter.on('collapse', data => {
				this.isCollapse = data.isCollapse;
			});

 */
			var configElement = document.getElementById( 'config-settings' );
			if (configElement && configElement.innerHTML != '') {
				this.config = JSON.parse( configElement.innerHTML );
				this.config.windowHeight = 600;
				this.setStyles();
			} else {
				axios.post('/settings/get', {},
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.config = response.data.settings;
							this.config.windowHeight = 600;
							this.setStyles();
						}
					}).catch(response => {;
				});
			}
			this.config.isMobile = Util.isMobile();
			this.$nextTick(() => {
				if(window.addEventListener) {
					window.addEventListener('resize', () => {
						this.windowHeight = window.innerHeight;
					});
				} else { //IE
					window.attachEvent('onresize',() => {
						this.windowHeight = window.innerHeight;
					});
				}
			});
			this.windowHeight = window.innerHeight;
		},
		mounted () {
			this.getHelp (this.$route.fullPath);
        	if (Util.isMobile()) {
		        document.body.classList.toggle('mini-sidebar');
        		this.isCollapse = true;
	        }
			this.windowHeight = window.innerHeight;

			setTimeout(()=>{
				window.dispatchEvent(new Event('resize'));
			},5000);
		},
		methods: {
			getHelp (helpPage) {
				axios.post('/systemtext/get', {SystemTextID : helpPage}
				)
					.then(response => {
						if (response.data.result == 'success') {
							if (response.data.SystemText) {
								this.helpText = response.data.SystemText.SystemText;
								this.pageText = response.data.SystemText.Params.PageText;
							} else {
								this.helpText = '';
								this.pageText = '';
							}
						}
					}).catch(response => {

				});

			},
            setStyles () {

	            let style = document.createElement('style')
	            document.head.append(style)
                style.innerText = '#app .bg-primary { background-color: ' + this.config.Params.PrimaryColor + ' !important;} ' +
					'#app .btn-primary {background-color: ' + this.config.Params.PrimaryColor + '; border-color: ' + this.config.Params.PrimaryColor + ';} ' +
					'#app .btn-primary:hover {opacity: 0.7; background-color: ' + this.config.Params.PrimaryColor + '; border-color: ' + this.config.Params.PrimaryColor + ';} ' +
	                '#app .text-primary, .el-dialog__title {   color: ' + this.config.Params.PrimaryColor + ' !important;} ' +
	                '#app a, #app ul.el-menu--vertical li.el-menu-item span, #app li.el-select-dropdown__item.selected, #app li.el-cascader-menu__item.is-active, #app div.el-tabs__item.is-active { color: ' + this.config.Params.PrimaryColor + ';}' +
					'#app .page-item.active a.page-link {background-color: ' + this.config.Params.PrimaryColor + ';border-color: ' + this.config.Params.PrimaryColor + ';} ' +
					'#app .VueTables__table th, div.el-tabs__active-bar {background-color: ' + this.config.Params.PrimaryColor + ';} ' +
					'.el-menu-vertical li.el-menu-item:hover i, ul.el-menu--vertical  a li:hover, .el-menu--vertical li.el-menu-item:hover i, .router-link-active i { color: ' + this.config.Params.PrimaryColor + ';}' +
					'#app .btn-link { color: ' + this.config.Params.PrimaryColor + ';}' +
					'#app .wizard__next, #app .wizard__back { background-color: ' + this.config.Params.PrimaryColor + ';} ' +
					'#app a.wizard__next:hover, #app a.wizard__back:hover { opacity: 0.5; background-color: ' + this.config.Params.PrimaryColor + ';} ' +
					'#app a.wizard__next span, #app a.wizard__next, #app a.wizard__back span { color: #fff;} ' +
					'.el-button--primary { background-color: ' + this.config.Params.PrimaryColor + '; border-color: ' + this.config.Params.PrimaryColor + ';}' +
					'.el-button--primary:hover { opacity: 0.7; background-color: ' + this.config.Params.PrimaryColor + '; border-color: ' + this.config.Params.PrimaryColor + ';}' +
					'.el-table__body tr.el-table__row.team-row td { background-color: ' + this.config.Params.PrimaryColor + '; color: #FFFFFF;}' +
					'.dashboard	div.el-table th { background-color: ' + this.config.Params.PrimaryColor + '; color: #FFFFFF;}' +
					'#app .el-table th { background-color: ' + this.config.Params.PrimaryColor + '; color: #FFFFFF;}'
					;

            }
		}
    }

</script>

<style lang="scss">
[v-cloak] {
    display: none;
}

@import "./assets/scss/helper.css";
@import "./assets/scss/style.css";
@import "./assets/scss/glyphicon.css";
@import '../../node_modules/bootstrap/scss/bootstrap.scss';
@import url("//use.fontawesome.com/releases/v5.6.1/css/all.css");

html, body {
	height: 100%;
}
.card-header{
	margin: -20px -20px 20px -20px;
}
.card-footer{
	margin: 20px -20px -20px -20px;
}
.card-text{
	padding: 10px;
}
#app i.fas, #app i.fa {
	font-family: "Font Awesome 5 Free Solid", "Font Awesome 5 Free" !important;
	font-weight: 900;
	text-rendering: optimizeLegibility;
}
#application {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	width: 100%;
    height: 100%;
}
div.el-message-box {
	width: 370px;
}
#app .toast-top-right {
	top: 62px;
}

#app .btn-primary {
	color: #fff;
}
#app .btn-primary:hover {
	color: #fff;
	background-color: #007bff;
	border-color: #007bff;
}
#app .card-header h5 {
	margin-bottom:0;
}
#app .page-item.active a.page-link {
	z-index: 1;
	color: #fff;
}

#app .VueTables__table th {
	color: #fff;
	white-space: nowrap;
}

#app .VueTables .VueTables__search {
	width: 250px;
	float:left;
}
#app .VueTables .VueTables__search label {
	margin-top: 10px;
	float:left;
}
#app .VueTables .VueTables__search input {
	float:right;
}

#app .VueTables .VueTables__limit {
	width: 120px;
	float:right;
}
#app .VueTables .VueTables__limit label {
	margin-top: 10px;
	float:left;
}
#app .VueTables .VueTables__limit select {
	float:right;
}

#app .VueTables .glyphicon {
	top: 3px;
}
#app .VueTables td {
	line-height: 20px;
}
.VuePagination {
  text-align: center;
}

.vue-title {
  text-align: center;
  margin-bottom: 10px;
}

.vue-pagination-ad {
  text-align: center;
}

.glyphicon.glyphicon-eye-open {
  width: 16px;
  display: block;
  margin: 0 auto;
}

.VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

.VueTables__child-row-toggler--closed::before {
  content: "+";
}

.VueTables__child-row-toggler--open::before {
  content: "-";
}
#app .VueTables__sortable th {
	white-space: nowrap;
}
.datatable_options {
	text-align: center;
}
.datatable_options a {
	margin: 0px 5px;
}
th.HomePhoneNumber {
	min-width: 140px;
}
#app .pull-right {
	float:none;
	margin-left: 10px;
}
#app .form-control:disabled.not-available {
		border : 0px;
		background: #fff;
		-webkit-appearance: none;
		margin: 0px 0px 0px -11px;
}
#app select::-ms-expand.form-control:disabled.not-available  {
        display: none;
}
#app .btn-link:hover,  #app a:hover {
	text-decoration: underline;
}
#app .wizard__step__indicator {
	background-color: #333;
}
#app .wizard__step.active .wizard__step__indicator, #app .wizard__next.final-step {
	background-color: #28a745;
}
#app .wizard__next.final-step:hover {
	background-color: #28a745;
	opacity: 0.5;
}
#app .el-form {
	width: 100%;
}
#app .el-select {
	width: auto;
}
#app .el-select.multiple {
	width: 100%;
}
#app .el-select.topDropdown, #app .el-select.fifty {
	width: 50%;
}
#app .el-select.oneHundred {
	width: 100%;
}
#app .el-form--label-top .el-form-item__label {
	margin:0;
	padding:0;
	line-height: 20px;
}
#app .el-form-item {
 	text-align: left;
 	width: 100%;
}

#app .left .el-tooltip__popper,
#app .right .el-tooltip__popper {
	padding: 8px 10px;
}
#app .el-tooltip__popper {
	z-index:9999    !important;
}
#app .el-tooltop {
	height: 20px;
	width: 20px;
	border-radius: 100%;
	margin: 0 5px;
}
#app .is-required .el-form-item__label:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}
#app .el-button.badge-success {
	color: #fff;
	background-color: #28a745;
}
#app .el-button.badge {
	display: inline-block;
	padding: 0.22em 0.4em;
	font-size: 75%;
	font-weight: 700;
	line-height: 1;
	text-align: center;
	white-space: nowrap;
	vertical-align: baseline;
	border-radius: 100%;
}
#app .el-menu-item {
	height: 35px;
	line-height: 31px;
}
.el-menu--vertical .el-menu--popup .el-menu-item {
	height: 35px;
	line-height: 23px;
}
#app .el-submenu__title {
	height: 35px;
	line-height: 35px;
	color: #FFF;
	border-bottom: 1px solid #666;
}
#app .el-submenu__title:hover {
	color: #333;
}
.el-menu--vertical .el-submenu .el-menu-item {
	height: 32px;
	line-height: 32px;
	min-width: 214px;
}
#app .el-sub-menu .el-menu {
	background-color: #000;
}
#app .el-sub-menu__title {
    height: 35px;
    line-height: 35px;
    color: #FFFFFF;
    border-bottom: 1px solid #666;
}
#app .el-collapse-item__header {
	font-size: 18px;
	color: #dc3545;
}
#app .el-alert {
	border: 1px solid #ccc;
}
#app .el-select__tags-text {
	color: #000;
}
#app .el-tag.el-tag--info {
	border: 1px solid #cccccc;
}
#app .smallNumber input, #app input.smallNumber {
	width: 75px;
	text-align: center;
}
#app .smallCurrency input {
	width: 120px;
	text-align: center;
}
#app .row {
	width: 100%;
	margin-left: 0px;
	margin-right: 0px;
}
#app .card-body {
	padding: .25rem;
}
.pageTextIntro {

}
.pageTextIntro {
	margin-bottom: 15px;
	padding-bottom: 10px;
	margin-left: 15px;
	border-bottom: 1px solid #ccc;
}
#app .el-table .cell {
  word-break: normal;
}
#app .el-menu-item i {
    color: #909399;
    line-height: 30px;
    margin-right: 5px;
}
#app .card-header.bg-primary h5 {
    color: #FFFFFF;
}
#app .mr-auto {
    margin-right: auto     !important;
}
</style>
